import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { ConditionAssociation } from 'types/Conditions';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';

export type ConditionTaxa = {
  id: string;
  association: ConditionAssociation;
  condition?: string;
  condition_id?: number;
  display_order?: number;
  indent?: number;
  kit_id?: string;
  taxa_evaluation?: string;
  taxa_evaluation_meaning?: string;
  taxonomy_name?: string;
  user_abundance?: string;
  category?: string;
};
const getConditionTaxa = async (kitId: string) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/conditions/taxa/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.CONDITIONS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
  return response?.result;
};

const useConditionsTaxa = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const conditionTaxaQuery = useQuery<ConditionTaxa[]>({
    queryKey: [apiName, 'getConditionTaxa', currentKitId],
    queryFn: async () => currentKitId && (await getConditionTaxa(currentKitId)),
    enabled: !!currentKitId,
  });

  return conditionTaxaQuery;
};

export default useConditionsTaxa;
